import { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import { VariantProps } from 'tailwind-variants';
import { linkStyle } from './styles';

interface ILinkProps
  extends AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof linkStyle> {}

export function Link({
  children,
  className,
  design,
  hoverVariant,
  href,
  size = 'md',
  target,
  textTransform,
  ...rest
}: PropsWithChildren<ILinkProps>): JSX.Element {
  return (
    <a
      className={linkStyle({
        textTransform,
        design,
        hoverVariant,
        size,
        className,
      })}
      href={href}
      target={target}
      {...rest}
    >
      {children}
    </a>
  );
}
